import { AddCandidate } from "../../../../models/addCandidate";
var AddCandidatesController = /** @class */ (function () {
    /*@ngInject*/
    function AddCandidatesController($rootScope, StorageService, candidateService, jobService, companyService, modalService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.StorageService = StorageService;
        this.candidateService = candidateService;
        this.jobService = jobService;
        this.companyService = companyService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    AddCandidatesController.prototype.$onInit = function () {
        // variables
        this.currentCompanyId = this.$rootScope.userDetails.company.companyId;
        this.userId = this.$rootScope.userDetails.id;
        // flags
        this.loadingResumeOptions = true;
        this.showResumeOptions = false;
        this.isAddCandidateForCorp = false;
        this.candidatesArray = [];
        this.savingFlag = false;
        this.controlObject = {};
        this.controlObject.disableCancelButtonFlag = false;
        this.addWithResumesFlag = true;
        this.sendOutreachEmail = false;
        this.isOutreachEnabled = false;
        this.isAddCandidateForCorp = this.companyService.isCorporateCompany() || (!_.isUndefined(this.corporateId) && this.corporateId !== "");
        this._setResumeOptions();
        this._checkIfOutreachEnabled();
    };
    AddCandidatesController.prototype._setResumeOptions = function () {
        var _this = this;
        var companyIdToCheckAUploadResumeAccess;
        // include clientOrBuId only for staffing company client
        if (this.isAddCandidateForCorp || (this.jobId == undefined || _.isNull(this.jobId) || this.jobId == "")) {
            this.clientOrBuId = null;
        }
        if (!_.isUndefined(this.corporateId) && this.corporateId !== "") {
            companyIdToCheckAUploadResumeAccess = this.corporateId;
        }
        else {
            companyIdToCheckAUploadResumeAccess = this.currentCompanyId;
        }
        //Check for resume options only for external reqs and shared reqs
        if (this.onlyUploadResume) {
            this.showResumeOptions = false;
            this.loadingResumeOptions = false;
        }
        else if ((this.isSharedJob && !_.isUndefined(this.corporateId) && this.corporateId !== "") || (!this.isAddCandidateForCorp)) {
            this.companyService.hasAccessToUploadResume(companyIdToCheckAUploadResumeAccess, this.clientOrBuId, function (data) {
                _this.showResumeOptions = !data;
                _this.addAnotherCandidate();
                if (_this.showResumeOptions) {
                    _this._setDefaultCandidateAddOption();
                }
                else {
                    _this.loadingResumeOptions = false;
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.addAnotherCandidate();
            this.showResumeOptions = true;
            this._setDefaultCandidateAddOption();
        }
    };
    AddCandidatesController.prototype._checkIfOutreachEnabled = function () {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    };
    AddCandidatesController.prototype._setDefaultCandidateAddOption = function () {
        var _this = this;
        if (this._isAddCandidateToJob()) {
            this.jobService.getLastCandidateAddOption(this.jobId, function (data) {
                if (data["lastAddCandidateOption"] == "Without Resume") {
                    _this.addWithResumesFlag = false;
                }
                else {
                    _this.addWithResumesFlag = true;
                }
                _this.loadingResumeOptions = false;
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.loadingResumeOptions = false;
        }
    };
    AddCandidatesController.prototype._isAddCandidateToJob = function () {
        return this.jobId !== undefined;
    };
    AddCandidatesController.prototype.onAddCandidateOptionChange = function () {
        this.StorageService.set('addCandidateWithResumeEnabled', this.addWithResumesFlag);
    };
    AddCandidatesController.prototype.addAnotherCandidate = function () {
        var addCandidate = new AddCandidate();
        addCandidate.jobId = this.jobId;
        addCandidate.companyId = this.currentCompanyId;
        addCandidate.addStatus = 'add';
        addCandidate.errorMessages = [];
        this.candidatesArray.push(addCandidate);
    };
    AddCandidatesController.prototype.removeCandidate = function (index) {
        this.candidatesArray.splice(index, 1);
    };
    AddCandidatesController.prototype.cancel = function () {
        var _this = this;
        if (this.addWithResumesFlag) {
            this.$rootScope.$broadcast('cancelUploadResume', null);
            if (this.context === 'candidateScreen') {
                if (this.saveCallback) {
                    this.saveCallback();
                }
            }
        }
        else {
            // add without resume
            var unsavedCandidatesExistFlag_1 = false;
            angular.forEach(this.candidatesArray, function (val, key) {
                if (val.addStatus != 'success') {
                    unsavedCandidatesExistFlag_1 = true;
                }
            });
            if (unsavedCandidatesExistFlag_1 && this.candidatesArray.length == 1) {
                // if only one candidate is there, check to ensure that it is not the default record that is shown.
                if (_.isUndefined(this.candidatesArray[0].firstName) && _.isUndefined(this.candidatesArray[0].lastName) && _.isUndefined(this.candidatesArray[0].emailId) && _.isUndefined(this.candidatesArray[0].phoneNumber)) {
                    // if it is the default candidate and all values are empty
                    unsavedCandidatesExistFlag_1 = false;
                }
            }
            if (unsavedCandidatesExistFlag_1) {
                bootbox.confirm({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                    message: "Are you sure you want to cancel ?<br> Unsaved data will be lost.",
                    className: "zIndex1060",
                    backdrop: true,
                    onEscape: false,
                    buttons: {
                        confirm: {
                            label: 'Yes',
                            className: 'btn-info'
                        },
                        cancel: {
                            label: 'Cancel',
                            className: 'btn-danger'
                        }
                    },
                    callback: function (result) {
                        if (result) {
                            if (_this.saveCallback) {
                                _this.saveCallback();
                            }
                        }
                        else {
                            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                        }
                    }
                });
            }
            else {
                if (this.saveCallback) {
                    this.saveCallback();
                }
            }
        }
    };
    AddCandidatesController.prototype.saveCandidates = function () {
        var _this = this;
        var candidatesArrayForSave = [];
        var candidateAddUIErrorExists = false;
        angular.forEach(this.candidatesArray, function (val, key) {
            if (val.addStatus != 'success') {
                candidatesArrayForSave.push(angular.copy(val));
                val.addForm.$submitted = true;
                if (val.addForm.$invalid) {
                    candidateAddUIErrorExists = true;
                }
            }
        });
        if (!candidateAddUIErrorExists) {
            var actualCandidatesArrayForSave = candidatesArrayForSave.map(function (y, index) {
                delete y.addForm;
                delete y.addStatus;
                delete y.errorMessages;
                return y;
            });
            if (actualCandidatesArrayForSave.length > 0) {
                this.savingFlag = true;
                this.candidateService.addCandidates(actualCandidatesArrayForSave, function (data) {
                    var allCandidatesAddedFlag = true;
                    var responseArrayIndexCounter = 0;
                    // iterate over candidates array and look for candidates whose current addStatus is not already 'success'
                    angular.forEach(_this.candidatesArray, function (val, key) {
                        // if status is not already a success, we have a candidate who was added in the current request
                        if (val.addStatus != 'success') {
                            if (data[responseArrayIndexCounter].status == 'PASSED') {
                                val.addStatus = 'success';
                            }
                            else {
                                allCandidatesAddedFlag = false;
                                val.addStatus = 'error';
                                val.errorMessages = data[responseArrayIndexCounter].messages;
                            }
                            // increment the responseArrayIndexCounter to be able to access the next candidate in the response
                            responseArrayIndexCounter++;
                        }
                    });
                    if (_this.sendOutreachEmail && allCandidatesAddedFlag) {
                        var passedCandidateList_1 = [];
                        if (data.length > 0) {
                            data.map(function (candidate) {
                                if (candidate.status === 'PASSED') {
                                    passedCandidateList_1.push({ id: candidate.candidateDetailDto.id, candidateType: "OWN_CANDIDATES" });
                                }
                            });
                        }
                        var outreachObject = {
                            candidates: passedCandidateList_1,
                            userId: _this.userId,
                            companyId: _this.currentCompanyId,
                            clientOrBuId: _this.clientOrBuId
                        };
                        if (outreachObject.candidates.length > 0) {
                            _this.candidateService.sendOutreachEmail(outreachObject, function (data) {
                                _this.savingFlag = false;
                                _this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                                _this.alertsAndNotificationsService.showAlertWithCallBack("Success!", "All candidates have been added successfully!", "success", function () {
                                    if (_this.saveCallback) {
                                        _this.saveCallback();
                                    }
                                });
                            }, function (error) {
                                _this.savingFlag = false;
                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            });
                        }
                        else {
                            _this.savingFlag = false;
                        }
                    }
                    else {
                        _this.savingFlag = false;
                        if (allCandidatesAddedFlag) {
                            _this.alertsAndNotificationsService.showAlertWithCallBack("Success!", "All candidates have been added successfully!", "success", function () {
                                if (_this.saveCallback) {
                                    _this.saveCallback();
                                }
                            });
                        }
                    }
                }, function (error) {
                    _this.savingFlag = false;
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }
        }
    };
    AddCandidatesController.prototype.onCandidateProcessed = function () {
        if (this.candidateProcessedCallback) {
            this.candidateProcessedCallback();
        }
    };
    return AddCandidatesController;
}());
AddCandidatesController.$inject = ['$rootScope', 'StorageService', 'candidateService', 'jobService', 'companyService', 'modalService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './add-candidates.html';
import * as TEMPLATE from 'raw-loader!./add-candidates.html';
export var AddCandidatesComponent = {
    bindings: {
        jobId: '@',
        isSharedJob: '<',
        onlyUploadResume: '<',
        singleUploadResume: '<',
        candidateId: '@',
        corporateId: '@',
        clientOrBuId: '@',
        saveCallback: '&',
        candidateProcessedCallback: '&',
        context: '@',
        sourceScreen: '@',
        formalizeActivityPayload: '<'
    },
    controller: AddCandidatesController,
    template: TEMPLATE.default
    // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/add-candidates.html'
};
//# sourceMappingURL=add-candidates.component.js.map